import { SegmentInstanceDocumentVersionAssociationType as ApiSegmentInstanceDocumentVersionAssociationType } from '@/services/generated/api';

export enum OtSegmentInstanceDocumentVersionAssociationTypeEnum {
  Originating = 'ORIGINATING',
  Supporting = 'SUPPORTING',
  Response = 'RESPONSE',
}

export class OtSegmentInstanceDocumentVersionAssociationType {
  public name!: string;
  public value!: OtSegmentInstanceDocumentVersionAssociationTypeEnum;

  public constructor(value: OtSegmentInstanceDocumentVersionAssociationTypeEnum, name: string) {
    this.value = value;
    this.name = name;
  }

  public static readonly Originating = new OtSegmentInstanceDocumentVersionAssociationType(
    OtSegmentInstanceDocumentVersionAssociationTypeEnum.Originating,
    'Originating',
  );
  public static readonly Supporting = new OtSegmentInstanceDocumentVersionAssociationType(
    OtSegmentInstanceDocumentVersionAssociationTypeEnum.Supporting,
    'Supporting',
  );
  public static readonly Response = new OtSegmentInstanceDocumentVersionAssociationType(
    OtSegmentInstanceDocumentVersionAssociationTypeEnum.Response,
    'Response',
  );
}

export const segmentInstanceDocumentVersionAssociationTypes: OtSegmentInstanceDocumentVersionAssociationType[] = [
  OtSegmentInstanceDocumentVersionAssociationType.Originating,
  OtSegmentInstanceDocumentVersionAssociationType.Supporting,
  OtSegmentInstanceDocumentVersionAssociationType.Response,
];

export const segmentInstanceDocumentVersionAssociationTypesMap: Map<
  string,
  OtSegmentInstanceDocumentVersionAssociationType
> = new Map(segmentInstanceDocumentVersionAssociationTypes.map(x => [x.value, x]));

export const parsedOtSegmentInstanceDocumentVersionAssociationType: {
  [key in ApiSegmentInstanceDocumentVersionAssociationType]: OtSegmentInstanceDocumentVersionAssociationType;
} = {
  [ApiSegmentInstanceDocumentVersionAssociationType.Originating]:
    OtSegmentInstanceDocumentVersionAssociationType.Originating,
  [ApiSegmentInstanceDocumentVersionAssociationType.Supporting]:
    OtSegmentInstanceDocumentVersionAssociationType.Supporting,
  [ApiSegmentInstanceDocumentVersionAssociationType.Response]: OtSegmentInstanceDocumentVersionAssociationType.Response,
};

export const parsedApiSegmentInstanceDocumentVersionAssociationType: {
  [key in OtSegmentInstanceDocumentVersionAssociationTypeEnum]: ApiSegmentInstanceDocumentVersionAssociationType;
} = {
  [OtSegmentInstanceDocumentVersionAssociationTypeEnum.Originating]:
    ApiSegmentInstanceDocumentVersionAssociationType.Originating,
  [OtSegmentInstanceDocumentVersionAssociationTypeEnum.Supporting]:
    ApiSegmentInstanceDocumentVersionAssociationType.Supporting,
  [OtSegmentInstanceDocumentVersionAssociationTypeEnum.Response]:
    ApiSegmentInstanceDocumentVersionAssociationType.Response,
};
